import React, { useState } from 'react';
import { FaSearch, FaChevronDown, FaChevronUp, FaQuestionCircle, FaGraduationCap, FaHome, FaMoneyBillWave, FaUsers, FaComments } from 'react-icons/fa';
import './Faq.css';
import { Link } from 'react-router-dom';
const Faq = () => {
  const categories = [
    { id: 'all', name: 'Tout', icon: <FaQuestionCircle /> },
    { id: 'admission', name: 'Admission', icon: <FaGraduationCap /> },
    { id: 'housing', name: 'Logement', icon: <FaHome /> },
    { id: 'finance', name: 'Financement', icon: <FaMoneyBillWave /> },
    { id: 'student-life', name: 'Vie étudiante', icon: <FaUsers /> }
  ];

  const [activeCategory, setActiveCategory] = useState('all');
  const [openQuestion, setOpenQuestion] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const faqData = [
    {
      id: 1,
      category: 'admission',
      question: 'Quels sont les documents requis pour une demande d\'admission ?',
      answer: 'Les documents généralement requis sont :\n• Relevés de notes des trois dernières années\n• Diplôme de baccalauréat\n• CV actualisé\n• Lettre de motivation\n• Pièce d\'identité valide\n• Certificat de niveau en langue française/anglaise'
    },
    {
      id: 2,
      category: 'admission',
      question: 'Quels sont les délais de réponse pour une candidature ?',
      answer: 'Le délai moyen de traitement d\'une candidature est de 4 à 6 semaines après réception du dossier complet. Pendant la période de forte affluence (mars-juin), les délais peuvent être légèrement plus longs.'
    },
    {
      id: 3,
      category: 'admission',
      question: 'Quels sont les critères d\'éligibilité pour postuler à des universités en France ?',
      answer: 'Les critères incluent généralement :\n• Être titulaire du baccalauréat ou équivalent pour une licence, ou d\'une licence pour un master.\n• Fournir une preuve de maîtrise de la langue (TCF, DELF, TOEFL, etc.).\n• Avoir un dossier académique solide.\n• Présenter une lettre de motivation pertinente.'
    },
    {
      id: 4,
      category: 'admission',
      question: 'Comment créer un compte Campus France ?',
      answer: 'Rendez-vous sur le site officiel de Campus France de votre pays. Créez un compte en fournissant vos informations personnelles, complétez votre profil avec vos diplômes et expériences, et suivez les instructions pour soumettre votre candidature.'
    },
    {
      id: 5,
      category: 'admission',
      question: 'Est-ce que je peux candidater à plusieurs universités en même temps ?',
      answer: 'Oui, vous pouvez postuler à plusieurs universités via Campus France ou directement sur les sites des universités concernées. Cela vous permet de multiplier vos chances d\'être admis.'
    },
    {
      id: 6,
      category: 'admission',
      question: 'Quels sont les délais pour postuler selon les rentrées universitaires ?',
      answer: 'Les délais varient selon les rentrées :\n• Pour la rentrée principale (septembre/octobre), les candidatures ouvrent en novembre/décembre de l\'année précédente et ferment entre février et avril.\n• Pour la rentrée secondaire (janvier/février), les candidatures se font généralement entre juin et septembre.\n• Consultez les sites des universités pour des informations précises.'
    },
    {
      id: 7,
      category: 'housing',
      question: 'Quels sont les types de logements disponibles pour les étudiants en France ?',
      answer: 'Voici les principales options de logement pour les étudiants :\n• Résidences universitaires (CROUS) : Logements subventionnés à faible coût.\n• Logements privés : Studios ou appartements via agences ou propriétaires.\n• Colocation : Partager un appartement pour réduire les frais.\n• Résidences étudiantes privées : Services inclus (Wi-Fi, laverie, etc.).\n• Hébergement chez l\'habitant : Convivial et souvent économique.\n• Coliving : Tendance combinant colocation et services inclus.'
    },
    {
      id: 8,
      category: 'housing',
      question: 'Comment trouver un logement à proximité de mon université ?',
      answer: 'Voici quelques conseils pour trouver un logement près de votre université :\n• Consultez les plateformes spécialisées comme Studapart ou LocService.\n• Rejoignez des groupes Facebook locaux pour des annonces.\n• Contactez le service d\'aide au logement de votre université.\n• Démarrez vos recherches plusieurs mois à l\'avance.\n• Privilégiez les logements bien desservis par les transports en commun.'
    },
    {
      id: 9,
      category: 'housing',
      question: 'Quels sont les documents nécessaires pour louer un logement en France ?',
      answer: 'Pour louer un logement, vous aurez besoin des documents suivants :\n• Une pièce d\'identité (passeport ou carte d\'identité).\n• Un justificatif d\'inscription universitaire.\n• Un justificatif de ressources (bourse, relevés bancaires, etc.).\n• Une garantie locative (attestation d\'un garant).\n• Une assurance habitation (obligatoire).'
    },
    {
      id: 10,
      category: 'housing',
      question: 'Que faire si je n\'ai pas de garant financier pour mon logement ?',
      answer: 'Si vous n\'avez pas de garant financier, voici des solutions alternatives :\n• Utiliser des garanties en ligne comme GarantMe ou Visale.\n• Opter pour des résidences étudiantes privées, qui demandent souvent moins de justificatifs.\n• Proposer une garantie bancaire auprès d\'une banque française.'
    },
    {
      id: 11,
      category: 'housing',
      question: 'Existe-t-il des aides financières pour le logement étudiant ?',
      answer: 'Oui, plusieurs aides financières sont disponibles pour les étudiants :\n• APL (Aide Personnalisée au Logement) : Aide versée par la CAF, dépendant de vos revenus et du type de logement.\n• ALS (Allocation de Logement Social) : Pour ceux qui ne sont pas éligibles à l\'APL.\n• Action Logement : Aide pour financer le dépôt de garantie ou le premier mois de loyer.\n• Réductions CROUS : Tarifs avantageux pour les boursiers dans les résidences universitaires.'
    },
    {
      id: 12,
      category: 'finance',
      question: 'Quelles sont les aides financières disponibles ?',
      answer: 'Plusieurs types d\'aides sont disponibles :\n• Bourses d\'études\n• Prêts étudiants\n• Aides au logement\n• Bourses de mobilité'
    },
    {
      id: 13,
      category: 'student-life',
      question: 'Quelles sont les activités proposées sur le campus ?',
      answer: 'De nombreuses activités sont proposées :\n• Associations étudiantes\n• Sports universitaires\n• Événements culturels\n• Clubs thématiques'
    },
    {
      id: 14,
      category: 'student-life',
      question: 'Comment s\'intégrer à la vie étudiante ?',
      answer: 'Voici quelques moyens pour bien s\'intégrer :\n• Participer aux événements d\'accueil\n• Rejoindre des associations étudiantes\n• Participer aux activités sportives\n• S\'inscrire aux sorties culturelles'
    }
  ];

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  const filteredFaqs = faqData.filter(faq => {
    const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
    const matchesSearch = searchQuery === '' || 
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <section className="faq-section" id="faq">
      <div className="faq-wrapper">
        {/* Header avec animation */}
        <div className="faq-header">
          <div className="title-container">
            <h2 className="faq-title">
              <span className="title-gradient">Questions fréquentes</span>
            </h2>
            <div className="faq-line">
              <div className="line-glow"></div>
            </div>
          </div>
          <p className="faq-intro">
            Trouvez rapidement les réponses à vos questions sur la procédure pour les études en France, 
            la vie étudiante en France et notre accompagnement.
          </p>
        </div>

        {/* Barre de recherche améliorée */}
        <div className="faq-search">
          <div className="search-container">
            <div className="search-icon-container">
              <FaSearch className="search-icon" />
            </div>
            <input
              type="text"
              placeholder="Rechercher une question ou un sujet..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            {searchQuery && (
              <button 
                className="search-clear"
                onClick={() => setSearchQuery('')}
              >
                ×
              </button>
            )}
          </div>
        </div>

        {/* Catégories avec icônes */}
        <div className="faq-categories">
          <div className="categories-scroll">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`category-btncategory ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <span className="category-iconcategory">{category.icon}</span>
                <span className="category-textcategory">{category.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Contenu FAQ avec compteur */}
        <div className="faq-content">
          <div className="faq-header-info">
            <div className="results-count">
              {filteredFaqs.length} question{filteredFaqs.length > 1 ? 's' : ''} trouvée{filteredFaqs.length > 1 ? 's' : ''}
            </div>
            <div className="faq-hint">
              Cliquez sur une question pour voir la réponse
            </div>
          </div>
          
          <div className="faq-list">
            {filteredFaqs.length > 0 ? (
              filteredFaqs.map((faq) => (
                <div 
                  className={`faq-item ${openQuestion === faq.id ? 'active' : ''}`} 
                  key={faq.id}
                >
                  <button 
                    className="faq-question" 
                    onClick={() => toggleQuestion(faq.id)}
                    aria-expanded={openQuestion === faq.id}
                  >
                    <div className="question-content">
                      <span className="question-number">Q{faq.id}</span>
                      <span className="question-text">{faq.question}</span>
                    </div>
                    <span className="toggle-icon">
                      {openQuestion === faq.id ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                  </button>
                  
                  <div className={`faq-answer ${openQuestion === faq.id ? 'open' : ''}`}>
                    <div className="answer-content">
                      <div className="answer-icon">
                        <FaComments />
                      </div>
                      <div className="answer-text">
                        {faq.answer.split('\n').map((line, index) => (
                          <p key={index} className="answer-line">
                            {line}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">
                <div className="no-results-icon">
                  <FaSearch />
                </div>
                <h3>Aucune question trouvée</h3>
                <p>Essayez d'autres mots-clés ou une autre catégorie</p>
                <button 
                  className="clear-search-btn"
                  onClick={() => {
                    setSearchQuery('');
                    setActiveCategory('all');
                  }}
                >
                  Voir toutes les questions
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Section contact améliorée */}
        <div className="faq-contact">
          <div className="contact-content">
            <div className="contact-icon">
              <FaComments />
            </div>
            <div className="contact-text">
              <h3>Vous n'avez pas trouvé la réponse à votre question ?</h3>
              <p>Notre équipe est là pour vous aider personnellement</p>
            </div>
         <Link to="/contact" className="contact-link">
  <span>Contactez-nous directement</span>
  <span className="link-arrow">→</span>
</Link>
          </div>
          <div className="contact-bg-glow"></div>
        </div>
      </div>
    </section>
  );
};

export default Faq;